import { styled } from 'styled-components';

export default styled.button<{
  height?: string;
  backgroundColor?: string;
  disabled?: boolean;
}>`
  font-family: 'Sanko';
  background-color: ${(props) => {
    if (props.disabled) {
      return 'gray';
    }
    return props.backgroundColor || 'rgba(240, 95, 102, 1)';
  }};
  border: 4pt solid rgba(1,1,1,1);
  border-bottom: 7pt solid black;
  border-right: 7pt solid black;

  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;

  text-align: center;
  text-decoration: none;
  color: white;
  font-size: 1.75rem;
  cursor: pointer;
  
  min-width: 0;
  width: auto;
  height: ${(props) => props.height || '40pt'};
  
  box-shadow: 0px 0px 0px 0px rgba(255,255,255,1);

  @media (hover: hover) {
    &:hover {
      ${(props) => {
        if (props.disabled) {
          return '';
        }
        return 'box-shadow: 3pt 3pt 0px 0px rgba(255,255,255,1)';
      }}
    }
  }

  @media only screen and (max-width: 720px) {
    // flex-wrap: wrap;
    // // flex-direction: column;
    // align-items: center;
    // justify-content: center;
    // gap: 10pt;

    font-size: 1.5rem;
  }
`;
